import { GameConstants } from './../../GameConstants';
import { GameVars } from "../../GameVars";
import { AudioManager } from '../../AudioManager';
import { GameManager } from '../../GameManager';
import * as Anuto from "../../../engine/src";
import { SelectTurretButton } from './gui/select-turret-menu/SelectTurretButton';
import { BattleManager } from './BattleManager';

export class FirstTutorialLayer extends Phaser.GameObjects.Container {

    private tutorialHand: Phaser.GameObjects.Image;
    private tutorialTween: Phaser.Tweens.Tween;

    private boardContainer: Phaser.GameObjects.Container;

    private flag: Phaser.GameObjects.Image;
    private buttonsContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bck.alpha = .5;
        bck.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bck.on("pointerup", () => { 
            // 
        });
        this.add(bck);

        this.boardContainer = new Phaser.GameObjects.Container(this.scene);
        this.boardContainer.x = GameConstants.GAME_WIDTH / 2;
        this.boardContainer.y = GameConstants.GAME_HEIGHT / 2 + GameConstants.CELLS_SIZE / 2;
        this.add(this.boardContainer);

        if (!this.scene.sys.game.device.os.desktop) {
            this.boardContainer.scaleX = GameVars.scaleX + GameVars.contrascaleX;
        }

        let offX = - GameConstants.CELLS_SIZE * GameVars.currentMapData.size.c / 2;
        let offY = - (GameConstants.CELLS_SIZE * GameVars.currentMapData.size.r / 2);

        this.tutorialHand = new Phaser.GameObjects.Image(this.scene, 352 + offX, 300 + offY, "texture_atlas_1", "hand-cursor");
        this.tutorialHand.setScale(-1);
        this.boardContainer.add(this.tutorialHand); 

        this.tutorialTween = this.scene.tweens.add({
            targets: this.tutorialHand,
            y: this.tutorialHand.y + 10,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            repeat: -1,
            yoyo: true
        });

        this.flag = this.scene.add.sprite(GameConstants.CELLS_SIZE * 5 + GameConstants.CELLS_SIZE / 2 + offX, (GameConstants.CELLS_SIZE * 6 + GameConstants.CELLS_SIZE / 2) - 12 + offY, "texture_atlas_1", "flag_build_1");
        this.flag.setInteractive(new Phaser.Geom.Rectangle(0, 12, GameConstants.CELLS_SIZE, GameConstants.CELLS_SIZE), Phaser.Geom.Rectangle.Contains);
        this.flag.on("pointerdown", this.onDownFlag, this);
        this.boardContainer.add(this.flag);

        this.buttonsContainer = new Phaser.GameObjects.Container(this.scene);
        this.buttonsContainer.x = GameConstants.CELLS_SIZE * 5 + GameConstants.CELLS_SIZE / 2 + offX;
        this.buttonsContainer.y = (GameConstants.CELLS_SIZE * 6 + GameConstants.CELLS_SIZE / 2) - 12 + offY;
        this.boardContainer.add(this.buttonsContainer);

        if (!this.scene.sys.game.device.os.desktop) {
            this.buttonsContainer.setScale(1 + (GameVars.aspectRatio - (4 / 3)) * .5);
            this.buttonsContainer.scaleX *= (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        }
    }

    public hideButtons(): void {

        this.buttonsContainer.destroy();

        this.tutorialTween.remove();

        let offX = - GameConstants.CELLS_SIZE * GameVars.currentMapData.size.c / 2;
        let offY = - (GameConstants.CELLS_SIZE * GameVars.currentMapData.size.r / 2);

        this.tutorialHand.x = offX + 125;
        this.tutorialHand.y = offY + 415;

        this.tutorialHand.setAngle(90);

        this.tutorialTween = this.scene.tweens.add({
            targets: this.tutorialHand,
            x: this.tutorialHand.x + 10,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            repeat: -1,
            yoyo: true
        });

        let nextWaveButton = new Phaser.GameObjects.Image(this.scene, offX + 45, offY + 415, "texture_atlas_1", "arrow_enemies");
        nextWaveButton.scaleX = 1;
        nextWaveButton.scaleX *= this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        nextWaveButton.setInteractive();
        nextWaveButton.on("pointerdown", () => { this.onClickNextWave(); });
        this.boardContainer.add(nextWaveButton);

    }

    private onClickNextWave(): void {

        AudioManager.playSound("btn_click");

        BattleManager.newWave();

        this.destroy();
    }

    private onDownFlag(): void {

        this.flag.destroy();

        this.tutorialTween.remove();

        let offY = - (GameConstants.CELLS_SIZE * GameVars.currentMapData.size.r / 2);
        this.tutorialHand.y = 300 + offY - 65;

        this.tutorialTween = this.scene.tweens.add({
            targets: this.tutorialHand,
            y: this.tutorialHand.y + 10,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            repeat: -1,
            yoyo: true
        });

        let numTurrets = 8;
        let radius = 60;

        let pos = [{x: 0, y: -radius}, {x: radius, y: -radius}, {x: radius, y: 0}, {x: radius, y: radius}, {x: 0, y: radius}, {x: -radius, y: radius}, {x: -radius, y: 0}, {x: -radius, y: -radius}];

        for (let i = 0; i < numTurrets; i++) {

            let selectTurretButton = new SelectTurretButton(this.scene, pos[i].x, pos[i].y, i, null, this);
            this.buttonsContainer.add(selectTurretButton);
        }

        AudioManager.playSound("btn_click");
    }
}